class ProductWhatsInside {
  constructor(section) {
    this.section = section;
    this.element = section;
    this.tabButtons = this.element.querySelectorAll(".nav-item");
    this.tabContents = this.element.querySelectorAll(".content-block");
    this.slider = this.element.querySelector(".whats-inside-tabs-content");
    this.sliderNav = this.element.querySelector(".whats-inside-tabs");
    this.nav = this.element.querySelector(".whats-inside-tabs");
    this.navButtons = this.nav.querySelectorAll(".nav-item");
    this.isUpdating = false;

    this.flickitySlider = null;
    this.flickitySliderNav = null;

    this._initFlickity();
    this._bindEvents();
    this._handleResize = this._handleResize.bind(this);
    window.addEventListener("resize", this._handleResize);
    this._positionFeatures();
  }

  _bindEvents() {
    this.tabButtons.forEach((button, index) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        if (!this.isUpdating) {
          this._setActiveTab(index);
        }
      });
    });
  }

  _setActiveTab(tabIndex) {
    if (this.isUpdating) return;
    this.isUpdating = true;

    this.tabButtons.forEach((button) => button.classList.remove("is-selected"));
    this.tabContents.forEach((content) =>
      content.classList.remove("is-selected")
    );

    this.tabButtons[tabIndex].classList.add("is-selected");
    this.tabContents[tabIndex].classList.add("is-selected");

    if (this.flickitySlider) {
      this.flickitySlider.select(tabIndex, false, true);
    }

    this.isUpdating = false;
  }

  _initFlickity() {
    const sliderOptions = {
      cellSelector: ".content-block",
      pageDots: false,
      prevNextButtons: false,
      draggable: true,
      wrapAround: false,
      selectedAttraction: 0.01,
      friction: 0.15,
      percentPosition: true,
      contain: true,
      cellAlign: "left",
    };

    // Add this for mobile
    if (window.innerWidth < 1024) {
      sliderOptions.adaptiveHeight = true; // Makes height dynamic
    }

    // Add partial slide view for tablet and up
    if (window.innerWidth >= 768) {
      sliderOptions.contain = false;
      sliderOptions.cellAlign = "center";
      sliderOptions.groupCells = false;
      sliderOptions.wrapAround = true;
      // Show partial next/previous slides
      sliderOptions.percentPosition = false;
      sliderOptions.adaptiveHeight = false;
    }

    this.flickitySlider = new Flickity(this.slider, sliderOptions);

    // Mobile nav slider
    if (window.innerWidth < 1024) {
      this.flickitySliderNav = new Flickity(this.sliderNav, {
        cellSelector: ".nav-item",
        pageDots: false,
        prevNextButtons: false,
        draggable: true,
        freeScroll: true,
        contain: true,
        cellAlign: "left",
      });
    }

    this.flickitySlider.on("select", () => {
      if (!this.isUpdating) {
        this._setActiveTab(this.flickitySlider.selectedIndex);
        this._positionFeatures();
      }
    });
  }

  _handleResize() {
    if (this.flickitySlider) {
      this.flickitySlider.destroy();
    }
    if (this.flickitySliderNav) {
      this.flickitySliderNav.destroy();
    }
    this._initFlickity();
    this._positionFeatures();
  }

  _positionFeatures() {
    const features = this.element.querySelectorAll(
      ".tab-features__item.desktop"
    );

    features.forEach((feature) => {
      const top = feature.dataset.top;
      const left = feature.dataset.left;

      if (top && left) {
        feature.style.top = `${top}%`;
        feature.style.left = `${left}%`;

        // Adjust transform based on left/right position
        if (feature.classList.contains("right")) {
          feature.style.transform = "translateX(-100%)";
        } else {
          feature.style.transform = "none";
        }
      }
    });
  }

  onSectionUnload() {
    if (this.flickitySlider) {
      this.flickitySlider.destroy();
    }
    if (this.flickitySliderNav) {
      this.flickitySliderNav.destroy();
    }
    window.removeEventListener("resize", this._handleResize);
  }
}

// Register the section
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (event) {
    if (
      event.detail.sectionId &&
      event.detail.sectionId.includes("product-whats-inside")
    ) {
      new ProductWhatsInside(event.target);
    }
  });
}

// Initialize sections on page load
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(
    '[data-section-type="product-whats-inside"]'
  );
  sections.forEach((section) => new ProductWhatsInside(section));
});
